import React, { useState, useEffect } from 'react'
import { getData } from '../../actions/servicesHttp'
import Header from '../../components/generals/header'
import Button from 'react-bootstrap/Button'
import DataTableDemo from '../../components/generals/datatables/datatable'
import stylesIndex from '../../css/Index.module.css'
import stylesDevices from '../../css/devices/Devices.module.css'
import ModalRoles from '../../components/modals/modalsRole/ModalRoles'
import store from '../../reducer/store'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'
import Loading from '../../components/generals/loading'

export default function Roles () {
  // ? urls de la API
  const [rolesUrl] = useState('roles')
  const { t } = useTranslation('roles')
  const navigate = useNavigate()

  // Estados para mostrar o no el modal
  const [modalsShow, setModalsShow] = useState({
    addRoles: false,
    editRoles: false
  })
  const [roles, setRoles] = useState(null)
  const [role, setRole] = useState()
  const { user } = store.getState()
  const roleView = user.roles

  //* llamador de datos de API
  const getRequest = async (url, data, set) => {
    const response = await getData(url, data, navigate)

    if (response.status === 200) {
      set(response.data)
    } else {
      set([])
    }
  }

  //* llamadas a API
  useEffect(() => {
    getRequest(rolesUrl, undefined, setRoles)
  }, [rolesUrl])

  const handleModal = (type, boolean) => {
    setModalsShow({ ...modalsShow, [type]: boolean })
  }

  const reload = () => {
    getRequest(rolesUrl, undefined, setRoles)
  }

  const openEditRole = (data) => {
    setRole(data)
    handleModal('editRoles', true)
  }

  return (
    <div className={`content-wrapper  ${stylesIndex.flexContent}`}>
      <div className={`content  ${stylesIndex.mainContent}`}>
          <Header title={t('title')} />

          <div
            className={`container-toggle ${stylesDevices.btns}`}
            // style={{ display: user.range === 1 ? 'flex' : 'none' }}
          >
            {roleView?.rolesPage.newRol && <Button onClick={() => handleModal('addRoles', true)} variant="dark">
              <i className="fas fa-tags" style={{ marginRight: '0.5rem' }}></i>
              {t('button1')}
            </Button>}
          </div>
          {roles === null && <Loading color="primary" />}
          {roles !== null && <DataTableDemo
            data={roles}
            actionDashboard={false}
            reload={reload}
            editUsers={roleView?.rolesPage.editRole !== undefined}
            editDataUser={openEditRole}
            exportsPdf={roleView?.rolesPage.exportPdfRoles !== undefined}
            exportsCsv={roleView?.rolesPage.exportCsvRoles !== undefined}
            actionDelete={roleView?.rolesPage.removeRole !== undefined}
            rowStates={false}
            rowSelecteds={false}
            table="roles"
            searchs={['roleName']}
            columns={[{ field: 'roleName', header: t('header') }]}
            namePdf={t('namePdf')}
          />}

          {/* //*MODAL PARA CREAR ROLES */}
            <ModalRoles
              show={modalsShow.addRoles}
              closeModal={() => handleModal('addRoles', false)}
              title="Crear rol"
              titleModal={t('roleModal.title1')}
              reload={reload}
              btnSuccess={t('roleModal.button1')}
              btnError={t('roleModal.button2')}
            />

            {/* //*MODAL PARA EDITAR ROLES */}
            <ModalRoles
              show={modalsShow.editRoles}
              closeModal={() => handleModal('editRoles', false)}
              title="Editar rol"
              titleModal={t('roleModal.title2')}
              data={role}
              reload={reload}
              btnSuccess={t('roleModal.button3')}
              btnError={t('roleModal.button2')}
            />
      </div>
    </div>
  )
}
